import React, { useState } from 'react'
import cn from 'classnames'

import styles from './Collapsible.module.css'

type CollapsibleProps = {
  title: string
}

export const Collapsible: React.FC<CollapsibleProps> = ({ title, children }) => {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <div
      className={cn(styles.root, {
        [styles.rootIsOpen]: isOpen,
      })}
    >
      <button type="button" onClick={() => setIsOpen(!isOpen)} aria-expanded={isOpen} className={styles.collapsibleButton}>
        <p className={styles.collapsibleTitle}>{title}</p>
        <span className={styles.collapsibleIcon}>▼</span>
      </button>

      <div className={styles.collapsibleDetails}>
        <div className="overflow-hidden">
          <div className="p-3">{children}</div>
        </div>
      </div>
    </div>
  )
}
